import { Component, forwardRef, Input } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
  selector: 'switcher',
  templateUrl: './switcher.component.html',
  styleUrls: [ './switcher.component.scss' ],
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SwitcherComponent),
    multi: true
  } ]
})
export class SwitcherComponent extends BaseInputComponent {

  @Input() offValue: any = false;
  @Input() onValue: any = true;

  @Input() formControl: FormControl;
}
